import { useState } from "react";
import Form from "@rjsf/core";
import validator from "@rjsf/validator-ajv8";

const DynamicForm = ({ schema, payload, postData, nonEditable = false }) => {
  const [highlightedFields, setHighlightedFields] = useState([]); ///Add Highlighters if needed
  const log = (type) => console.log.bind(console, type);

  const uiSchema = Object.keys(schema.properties).reduce((acc, key) => {
    acc[key] = { "ui:title": schema.properties[key].uiLabel || key };

    if (schema.properties[key].type === "array") {
      acc[key]["ui:title"] = schema.properties[key].uiLabel || key;

      if (
        schema.properties[key].items &&
        schema.properties[key].items.uiLabel
      ) {
        acc[key].items = {
          "ui:title": schema.properties[key].items.uiLabel,
          properties: {},
        };

        Object.keys(schema.properties[key].items.properties).forEach(
          (itemKey) => {
            acc[key].items.properties[itemKey] = {
              "ui:title":
                schema.properties[key].items.properties[itemKey].uiLabel ||
                itemKey,
            };
          }
        );
      }
    }

    return acc;
  }, {});

  const onSubmit = ({ formData }, errors) => {
    if (errors.length > 0) {
      const requiredFields = errors
        .filter(
          (error) =>
            error.property === "instancePath" && error.name === "required"
        )
        .map((error) => error.params.missingProperty);

      setHighlightedFields(requiredFields);
      console.log("Form has errors:", errors);
    } else {
      if (formData) postData(formData);
      console.log("Form submitted successfully:", formData);
      setHighlightedFields([]);
    }
  };

  return (
    <Form
      schema={schema}
      validator={validator}
      uiSchema={uiSchema}
      formData={payload}
      onSubmit={onSubmit}
      readonly={nonEditable}
      children={nonEditable}
    />
  );
};

export default DynamicForm;
